import { useState } from 'react'
import { IAPISimulationSuite } from 'extra/types/ApiModels'
import { SimulationItems } from './SimulationItems'
import { SimulationSettings } from './SimulationSettings'

export function SimulationDetail ({
  suite,
}: {
  suite: IAPISimulationSuite
}) {
  const [activeTab, setActiveTab] = useState<'items' | 'settings'>('items')

  return (
    <div>
      <div className="mb-4 border-b border-gray-800">
        <nav className="flex gap-4">
          <button
            onClick={() => setActiveTab('items')}
            className={`px-3 py-1.5 text-sm transition-colors cursor-pointer ${activeTab === 'items' ? 'text-blue-400 border-b-2 border-blue-400' : 'text-gray-400 hover:text-white'}`}
          >
            Items
          </button>
          <button
            onClick={() => setActiveTab('settings')}
            className={`px-3 py-1.5 text-sm transition-colors cursor-pointer ${activeTab === 'settings' ? 'text-blue-400 border-b-2 border-blue-400' : 'text-gray-400 hover:text-white'}`}
          >
            Settings
          </button>
        </nav>
      </div>

      {activeTab === 'items'
        ? <SimulationItems suite={suite} />
        : <SimulationSettings suite={suite} />}
    </div>
  )
}
